import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Team } from '../../../../../../hat/assets/js/apps/Iaso/domains/teams/types/team';
import {
    Nullable,
    Optional,
} from '../../../../../../hat/assets/js/apps/Iaso/types/utils';
import { Profile } from '../../../../../../hat/assets/js/apps/Iaso/utils/usersUtils';
import { fileExtensions } from '../../constants/fileExtensions';
import { FileWithName, LinkWithAlias, Round } from './types';

export const formatUserName = (profile: Profile): string => {
    return profile?.first_name && profile?.last_name
        ? `${profile.first_name} ${profile.last_name}`
        : (profile?.user_name ?? `${profile?.user_id}`);
};

export const formatRoundNumber = (roundNumber: number | string): string => {
    return `Round ${roundNumber}`;
};

export const formatRoundNumbers = (roundNumbers: Round[]): string => {
    return roundNumbers.map(i => formatRoundNumber(i.number)).join(', ');
};

export const formatTargetTeams = (
    targetTeams: number[],
    teams: Team[],
): string => {
    return targetTeams?.length === 0
        ? // TODO translate or throw error
          'None'
        : targetTeams
              .map(
                  (target_team: number) =>
                      teams?.find(team => team.id === target_team)?.name,
              )
              .join(', ');
};

export const extractFileName = (fileUrl: string): string => {
    let trimmedLeft = '';
    let i = 0;
    // find the end of file name by searching for the extension
    while (trimmedLeft === '' && i < fileExtensions.length) {
        const currentExtension = fileExtensions[i];
        if (fileUrl?.indexOf(currentExtension) !== -1) {
            trimmedLeft = `${
                fileUrl?.split(currentExtension)[0]
            }${currentExtension}`;
        }
        i += 1;
    }
    // The name is the behind the last slash, so we find it by splitting
    const removedSlashes = trimmedLeft.split('/');
    return removedSlashes[removedSlashes.length - 1];
};

const truncateFileName = (fileName: string) => {
    if (fileName.length <= 30) return fileName;
    const separator = '...';
    const end = fileName.substring(fileName.length - 5, fileName.length);
    const start = fileName.substring(0, 22);
    return `${start}${separator}${end}`;
};

export const makeFileLinks = (files: FileWithName[]): React.ReactNode => {
    return files.map((file, index) => {
        return (
            // fine here as we cannot really deduct something unique from file
            // eslint-disable-next-line react/no-array-index-key
            <Link key={`${file.filename}-${index}`} download to={file.file}>
                {/* @ts-ignore */}
                <Typography variant="body2" style={{ wordWrap: 'anywhere' }}>
                    {truncateFileName(file.filename)}
                </Typography>
            </Link>
        );
    });
};

export const makeLinks = (
    links: Optional<Nullable<LinkWithAlias[]>>,
): Nullable<any[]> => {
    if (!links) return null;
    return links.map(link => {
        return (
            <Link key={`${link.alias}-${link.url}`} download to={link.url}>
                {/* @ts-ignore */}
                <Typography variant="body2" style={{ wordWrap: 'anywhere' }}>
                    {link.alias}
                </Typography>
            </Link>
        );
    });
};
